import { render, staticRenderFns } from "./OrderLineItems.vue?vue&type=template&id=38f96ec2&scoped=true"
import script from "./OrderLineItems.vue?vue&type=script&lang=js"
export * from "./OrderLineItems.vue?vue&type=script&lang=js"
import style0 from "./OrderLineItems.vue?vue&type=style&index=0&id=38f96ec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f96ec2",
  null
  
)

export default component.exports